module.exports = __webpack_public_path__ + "42f338e2fa91237c42a06cb1b81f03c0.svg";